// LIST
export const FETCH_SETTINGS = "app/ReviewSettings/FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS =
  "app/ReviewSettings/FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_FAILURE =
  "app/ReviewSettings/FETCH_SETTINGS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/ReviewSettings/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/ReviewSettings/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/ReviewSettings/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_SETTINGS = "app/ReviewSettings/ADD_SETTINGS";
export const ADD_SETTINGS_SUCCESS = "app/ReviewSettings/ADD_SETTINGS_SUCCESS";
export const ADD_SETTINGS_FAILURE = "app/ReviewSettings/ADD_SETTINGS_FAILURE";
// EDIT
export const EDIT_SETTINGS = "app/ReviewSettings/EDIT_SETTINGS";
export const EDIT_SETTINGS_SUCCESS = "app/ReviewSettings/EDIT_SETTINGS_SUCCESS";
export const EDIT_SETTINGS_FAILURE = "app/ReviewSettings/EDIT_SETTINGS_FAILURE";
// DELETE
export const DELETE_SETTINGS = "app/ReviewSettings/DELETE_SETTINGS";
export const DELETE_SETTINGS_SUCCESS =
  "app/ReviewSettings/DELETE_SETTINGS_SUCCESS";
export const DELETE_SETTINGS_FAILURE =
  "app/ReviewSettings/DELETE_SETTINGS_FAILURE";
